import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid2,
  IconButton,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as SuccessIcon } from "Assets/Icons/Settings/SuccessIcon.svg";
import { ReactComponent as CloseIcon } from "Assets/Icons/Home/CloseIcon.svg";
import { ReactComponent as NotificationIcon } from "Assets/Icons/Home/NotificationIcon.svg";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import { toast } from "react-toastify";
import { addFriendsProgram } from "Slices/thunks";

const AddFriendsProgram = ({ open, setOpen, friendDetails, setFriendDetails, checkStatus  }) => {
  const dispatch = useDispatch();
  const [selectedProgram, setSelectedProgram] = useState();

  const { Program, Translation } = useSelector((state) => ({
    Program: state.ReferralReward.program || [],
    Translation: state.Translation.translation?.Referral || {},
  }));

  const handleClose = () => setOpen(false);

  const onSubmit = async (program) => {
    try {
      setSelectedProgram(program.ID);
      const mobiles = friendDetails.map((item) => item.Mobile);
      dispatch(addFriendsProgram({ ProgramID: program.ID, Mobiles: mobiles }))
      toast.success(Translation?.AddedSuccessfully);
    } catch (error) {
      toast.error(Translation?.SomethingWentWrong);
    }
  };

  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={handleClose}>
      <DialogTitle sx={(theme) => ({
        background: theme.palette.success.light,
      })}>
        <Box display={"flex"} flexDirection={"row"} alignItems={"center"} gap="8px">
            <PrimaryIcon
                width="32px"
                height="32px"
                icon={SuccessIcon}
            />
            <Typography variant="subtitle" fontWeight={500} color="success">
                {Translation?.RefereeDetials}
            </Typography>
        </Box>
        <IconButton onClick={handleClose}>
            <PrimaryIcon icon={CloseIcon} height="14px" width="14px" />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
            
          {/* <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            borderRadius="8px"
            padding="8px 16px"
            sx={(theme) => ({
                background: theme.palette.background.default,
            })}
            gap="8px"
          >
            <Typography variant="subtitle1" fontWeight={500}>
              1&nbsp;
            </Typography>
            <Typography variant="subtitle1" fontWeight={500}>
              Pankaj
            </Typography>
          </Box> */}

          <Grid2 container spacing={2} justifyContent="center">
            { Array.isArray(friendDetails) && friendDetails.map((item, index) => {
                return (
                <Grid2 item xs={6} sm={4} md={3}>
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        borderRadius="8px"
                        sx={(theme) => ({
                            background: theme.palette.background.default,
                        })}>
                        <Typography variant="subtitle1" fontWeight={500}
                            padding="8px 16px"
                            borderRadius="8px"
                            sx={(theme) => ({
                                background: theme.palette.success.light,
                            })}
                        >
                            {index + 1}
                        </Typography>
                        <Typography variant="subtitle1" fontWeight={500}
                         padding="8px 16px"
                        >
                            {item.FullName}
                        </Typography>
                    </Box>
                </Grid2>
                )
            })}

          </Grid2>

          <Box display={"flex"} flexDirection={"row"} gap="8px">
            <PrimaryIcon
                width="16px"
                height="16px"
                icon={NotificationIcon}
                fill={false}
            />
            <Typography variant="body2">
                {Translation?.ContactFriendShortly}
            </Typography>
          </Box>

          <Typography variant="subtitle1" fontWeight={500}>
            {Translation?.PleaseSelectReferProgram}
          </Typography>

          <Grid2 container spacing={2} justifyContent="center">
            {Array.isArray(Program) &&
              Program.map((item) => (
                <Grid2 item xs={6} sm={4} md={3} key={item.ID}>
                  <Button
                    fullWidth
                    color={item.ID !== selectedProgram ? "secondary": "primary"}
                    variant={
                      item.ID === selectedProgram ? "contained" : "outlined"
                    }
                    onClick={() => onSubmit(item)}
                  >
                    {item?.Name}
                  </Button>
                </Grid2>
              ))}
          </Grid2>
        </Box>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", mb: 2 }}>
        <Typography variant="body2" fontWeight={500}>
          {Translation?.CheckReferralStatus}
        </Typography>
        <Button variant="outlined" onClick={checkStatus}>
          {Translation?.CheckStatus}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddFriendsProgram;